import React from 'react';

export default ({ email }) => <a href={'mailto:' + email}>{email}</a>
